import React from 'react';
import { getResourceString } from '../../reactcomponents/kentico/resource-strings';
import { ILocationFinderItem, IOpeningHours } from '../../reactcomponents/services/regional/interfaces';

export function Locations(locations: ILocationFinderItem[], widgetId: string) {
  return (
    <>
      <h6 className="mb-2">Kies locatie</h6>
      <div id={"location-accordion-" + widgetId}>
        {locations.length ? locations.length > 3 &&
          <p>{getResourceString('LocationFinder.AllResults')}</p> : ''}
        {locations.length ? locations.map((location, index) => {
          var myid = widgetId + '_' + index;
          return (
            <div key={location.officeId + '_' + myid} className='card' style={{ border: 0 }}>
              <div className="card-header choose-location__location" id={'heading_' + myid} data-toggle="collapse" data-target={'#collapse_' + myid} aria-expanded={'false'} aria-controls={'collapse_' + myid}>
                <img className='choose-location__marker' srcSet='/assets/img/layout/map-marker.svg' alt='locatie' />
                <span>
                  <strong>{location.officeName},</strong>{" "}
                  {location.address}
                </span>
              </div>
              <div id={'collapse_' + myid} className={'collapse'} aria-labelledby={'heading_' + myid} data-parent={"#location-accordion-" + widgetId}>
                <div className="card-body">

                  {location.messages !== undefined && location.messages.length > 0 ?
                    <div className="row content__callout content__callout--in-content content__callout-yellow content__callout--no-margin mt-0 ml-0">
                      <div className="col-auto content__callout-icon-container content__callout-tip">
                        <span className="icon icon-idea"></span>
                      </div>
                      <div className="col content__callout-content"><ul className='mb-0'>
                        {location.messages?.map((message, mindex) => {
                          return (
                            <li key={'message_' + index + mindex} dangerouslySetInnerHTML={{ __html: message }}></li>
                          );
                        })} </ul></div></div> : ''}

                  {location.services !== undefined && location.services.length >= 1 ? <>
                    <p className='mb-0 text'><strong>Diensten</strong></p>
                    {location.services?.map((service, sindex) => {
                      return (
                        <div className='row' key={'service_' + widgetId + '_' + sindex}>
                          <div className='col'>
                            <p className='m-0 text'>{service}</p>
                          </div>
                        </div>
                      );
                    })}</> : ''}

                  <div className='row'>
                    <div className='col-12 my-3'>
                      <a href={location.url} className='btn btn-success text-white pr-2 pe-2'>Bekijk deze locatie
                        <span className='ml-3 ms-3 icon icon-open-chevron-right small'></span>
                      </a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          );
        }) : <p>{getResourceString('LocationFinder.NoResults')}</p>}

      </div>
    </>
  );
}